module.exports = __webpack_public_path__ + "img/blockdit.5649b253.svg";